module.exports = {"home":"Home","freelance":"Freelance","ressources":"Ressources","skills":"Compétences","projects":"Projets","contact":"Contact"}